<template>
  <div class="status-dashboard">
    <div
      v-show="!loadStatus"
      v-for="(status, key) in statuses"
      :key="`status-${status.pk}`"
      class="status-card"
      :class="{
        noProducts: status.products.length === 0
      }"
    >
      <!-- Títulos de estados de las subórdenes -->
      <p
        class="dashboard-title"
        :style="{
          'background-color': status.color,
          color: status.dark ? '#fff' : '#000'
        }"
      >
        {{ $tc(status.name.replace(' - ', '_')) }}
      </p>

      <!-- Zona de gestión de las subórdenes -->
      <div
        class="suborders-container"
        drake="first"
        :data-status="status.pk"
        v-dragula="status.products"
      >
        <!-- Suborden -->
        <v-card
          v-for="product in status.products"
          class="elevation-1 suborder"
          :key="`product-${product.pk}`"
          :data-block-id="`item+-${product.pk}+-${key}`"
          :data-key="product.pk"
          :style="{ ...stylesList[key].card }"
        >
          <!-- Cabecera de la suborden -->
          <div class="d-flex justify-content-between align-items-center">
            <span
              class="suborder-chip"
              :style="{ ...stylesList[key].customerTitle }"
            >
              {{ product.customerName || product.customerFullname }}
            </span>
            <span class="font-weight-medium text-caption text-uppercase px-2">
              {{ product.projectName }}
            </span>
            <v-btn class="p-3" x-small icon @click="expanded(product.pk)">
              <v-icon
                v-text="
                  !expand[product.pk] ? 'fa-chevron-down' : 'fa-chevron-up'
                "
              ></v-icon>
            </v-btn>
          </div>

          <!-- Información de la suborden y botones -->
          <div v-show="expand[product.pk]" class="suborder-data">
            <i-image
              class="product-image"
              :style="{
                width: '5rem !important',
                height: '4rem !important'
              }"
              :value="product.thumbnail"
              :preview="true"
              :readonly="true"
            />
            <div>
              <!-- Nombre del producto -->
              <p class="mb-1">{{ product.productName }}</p>

              <!-- Fecha y Fecha de compromiso -->
              <div v-if="!showOrderUser[product.pk]">
                <p
                  class="mb-0"
                  v-for="(date, index) in product.datesOrder"
                  :key="`order-dates-${product.pk}-${index}`"
                >
                  <b>{{ $t(date.type) }}:</b>
                  {{ dateFormat(date.date) }}
                </p>

                <!-- Fechas extra -->
                <p
                  class="mb-0"
                  v-for="date in product.dates"
                  :key="`dates-${date.pk}`"
                >
                  <b>{{ date.type }}:</b>
                  {{ dateFormat(date.date) }}
                  <v-chip v-if="date.changeDate" x-small color="primary">
                    {{ $tc('change', 0) }}
                  </v-chip>
                </p>
              </div>
              <user-assigned
                ref="dialAssignUser"
                :key="`order-dates-${product.pk}`"
                v-else
                :mode="userModalMode[product.pk]"
                :selectedItem="product.designers"
                :department="product.department"
              />
            </div>
            <div class="suborder-buttons">
              <!-- Abrir modal de suborden -->
              <v-btn
                v-if="
                  checkPermissions.isElevatedRole || checkPermissions.isDesigner
                "
                class="p-2"
                icon
                x-small
                @click="openSuborder(product.pk)"
              >
                <v-icon>fa fa-pen-to-square</v-icon>
              </v-btn>

              <!--
                Al parecer el botón de calendario no hace nada, supongo que
                debería llevar al dashboard pero a la sección de calendario.
                Por ahora le quité el
                @click.prevent="modeView = 1"
                porque servía para nada
              -->
              <v-btn class="p-2" icon x-small>
                <v-icon>fa fa-calendar</v-icon>
              </v-btn>

              <!-- Botón de gestión de usuarios (diseñador) de la suborden -->
              <v-btn
                v-if="
                  filter != 1 &&
                  product.designers.length > 0 &&
                  product.parentStatus !== 'quote' &&
                  !product.status.includes('preprocess') &&
                  product.status.includes('design')
                "
                class="p-2"
                icon
                x-small
                @click.prevent="showOrderUserModal(product)"
              >
                <v-icon>fa fa-users</v-icon>
              </v-btn>

              <!-- Botón de gestión de usuarios (productor) de la suborden -->
              <v-btn
                v-if="
                  filter != 1 &&
                  product.department &&
                  product.parentStatus !== 'quote' &&
                  !product.status.includes('preprocess') &&
                  product.status.includes('production')
                "
                class="p-2"
                icon
                x-small
                @click.prevent="showOrderUserModal(product)"
              >
                <v-icon>fas fa-users-cog</v-icon>
              </v-btn>
            </div>
          </div>

          <!-- Estado y botón de acciones -->
          <v-row
            v-show="expand[product.pk] !== undefined && expand[product.pk]"
            class="suborder-footer"
            no-gutters
          >
            <div :style="{ ...stylesList[key].statusIndicate }">
              {{ $tc(product.status.replace(' - ', '_')) }}
            </div>
            <div class="text-center">
              <v-menu v-if="checkPermissions.isElevatedRole" offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    x-small
                    :color="status.color"
                    @click="
                      getQuoteInfo(product.orderProduct, product.customerPK)
                    "
                    v-on="on"
                  >
                    <v-icon>fa-ellipsis-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <!-- Enviar cotización -->
                  <v-list-item
                    v-if="
                      checkPermissions.isElevatedRole &&
                      product.status === 'preprocess - quote'
                    "
                  >
                    <i-btn
                      classes="mx-1"
                      color="success"
                      icon="fa-paper-plane"
                      outlined
                      :title="$tc('send_quote')"
                      @click="manageQuote('send')"
                    />
                  </v-list-item>

                  <!-- Aprobar cotización -->
                  <v-list-item
                    v-if="
                      checkPermissions.isElevatedRole &&
                      (product.status.includes('quote') ||
                        product.status.includes('sended_quote'))
                    "
                  >
                    <i-btn
                      classes="mx-1"
                      color="success"
                      icon="fa-check"
                      outlined
                      :title="$t('aproved_quote')"
                      @click="manageQuote('approved')"
                    />
                  </v-list-item>

                  <!-- Agregar productos al carrito / Ir a la orden -->
                  <v-list-item v-if="checkPermissions.isElevatedRole">
                    <i-btn
                      v-if="product.parentStatus === 'quote'"
                      classes="mx-1"
                      color="info"
                      icon="fa-cart-plus"
                      outlined
                      :title="`${$t('add', {
                        value: $tc('product', 2)
                      })}`"
                      @click="changeRoute({ pk: product.orderProduct }, 2)"
                    />
                    <i-btn
                      v-else
                      classes="mx-1"
                      color="primary"
                      icon="fa-list-ol"
                      outlined
                      :title="$t('sale_order')"
                      @click="changeRoute({ pk: product.orderProduct })"
                    />
                  </v-list-item>

                  <!-- Asignar diseñador -->
                  <v-list-item
                    v-if="
                      checkPermissions.isElevatedRole &&
                      product.status.includes('design') &&
                      !product.status.includes('design_under_review') &&
                      !product.status.includes('design - in_process')
                    "
                  >
                    <i-btn
                      classes="mx-1"
                      color="primary"
                      icon="fa-user"
                      outlined
                      :title="
                        $t('assign_people', {
                          value: $t('designer')
                        })
                      "
                      @click="showModalAssignDesigner(product.pk)"
                    />
                  </v-list-item>

                  <!-- Asignar Departamento -->
                  <v-list-item
                    v-if="
                      checkPermissions.isElevatedRole &&
                      product.status.includes('production') &&
                      product.status.includes('production - in_wait')
                    "
                  >
                    <i-btn
                      classes="mx-1"
                      color="primary"
                      icon="fa-user-gear"
                      outlined
                      :title="
                        $t('assign_people', {
                          value: $tc('department')
                        })
                      "
                      @click="showModalAssignProductor(product.pk)"
                    />
                  </v-list-item>

                  <!-- Descargar cotización en PDF -->
                  <v-list-item v-if="checkPermissions.isElevatedRole">
                    <i-btn
                      classes="mx-1"
                      color="error"
                      icon="fa-file-download"
                      outlined
                      :title="$t('download', { value: $t('quote') })"
                      @click="
                        generatePDF(
                          product.orderProduct,
                          true,
                          product.code,
                          product.quotation_code,
                          product.parentStatus
                        )
                      "
                    />
                  </v-list-item>

                  <!-- Mostrar la cotización en una ventana -->
                  <v-list-item v-if="checkPermissions.isElevatedRole">
                    <i-btn
                      classes="mx-1"
                      color="error"
                      icon="fa-file-pdf"
                      outlined
                      :title="$t('print', { value: $t('quote') })"
                      @click="
                        generatePDF(
                          product.orderProduct,
                          false,
                          product.code,
                          product.quotation_code,
                          product.parentStatus
                        )
                      "
                    />
                  </v-list-item>

                  <!-- Ir a la cuenta por cobrar -->
                  <v-list-item
                    v-if="
                      checkPermissions.isElevatedRole &&
                      product.parentStatus !== 'quote' &&
                      product.parentStatus !== 'sended_quote' &&
                      product.parentStatus !== 'approved'
                    "
                  >
                    <i-btn
                      classes="mx-1"
                      color="secondary"
                      icon="fa-file-invoice"
                      outlined
                      :title="$t('receivable')"
                      @click="goToReceivable(product.orderProduct)"
                    />
                  </v-list-item>

                  <!-- Cancelar cotización -->
                  <v-list-item v-if="checkPermissions.isElevatedRole">
                    <i-btn
                      classes="mx-1"
                      color="error"
                      icon="fa-times"
                      outlined
                      :title="`${$t('cancel')} ${$t('quote')}`"
                      @click="manageQuote('canceled')"
                    />
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-row>
        </v-card>

        <!-- Modal para asignar diseñador -->
        <i-modal
          v-if="checkPermissions.isElevatedRole && showAssignDesignerModal"
          dontSave
          max-width="800px"
          persistent
          :title="$tc('assignDesigner')"
          v-model="showAssignDesignerModal"
        >
          <div class="py-3">
            <assign-designer
              mode="designer"
              :selectedItem="modalProduct"
              :template="template"
              @wasAssigned="softUpdate"
            />
          </div>
        </i-modal>

        <!-- Modal para asignar productor -->
        <i-modal
          v-if="checkPermissions.isElevatedRole && showAssignProductorModal"
          dontSave
          max-width="800px"
          persistent
          :title="$tc('assignProducer')"
          v-model="showAssignProductorModal"
        >
          <div class="py-3">
            <assign-designer
              mode="production"
              :selectedItem="modalProduct"
              :template="template"
              @wasAssigned="softUpdate"
            />
          </div>
        </i-modal>
      </div>
    </div>

    <!-- Modal de subórdenes de venta -->
    <dial-prod
      v-if="checkPermissions.isElevatedRole || checkPermissions.isDesigner"
      ref="dialprod"
    />

    <!-- Componente de cotizaciones, no se renderiza en el DOM pero se usa -->
    <quote
      v-if="checkPermissions.isElevatedRole && quotationData.load"
      v-show="false"
      :status="quotationData.status"
      :cartlist="quotationData.cartlist"
      :order="quotationData.order"
      :customer="quotationData.customer"
      @done="updateStatuses"
      ref="quote"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import AssignDesigner from '@/components/sale/infoAssignItem.vue'
import UserAssigned from '@/components/sale/userAssigned.vue'
import DialProd from '@/components/sale/DialogProduct.vue'
import Quote from '@/components/sale/quotation.vue'
export default {
  components: {
    AssignDesigner,
    UserAssigned,
    DialProd,
    Quote
  },
  props: {
    preStatuses: {
      type: Array
    },
    filter: {
      type: Number
    },
    template: {
      type: Number
    }
  },
  data() {
    return {
      loading: false,
      loadStatus: false,
      theOrder: '',
      stylesList: [],
      statuses: [],
      departments: [],
      expand: {},
      nav: 1,
      modeView: 1,
      newStatus: '',
      oldStatus: '',
      product: '',
      showAssignDesignerModal: false,
      showAssignProductorModal: false,
      modalProduct: '',
      showAssigUser: false,
      showOrderUser: {},
      userModalMode: {},
      cartlist: [],
      order: {
        mainStatus: 'designer'
      },
      quotationData: {
        load: false,
        status: '',
        cartlist: [],
        order: '',
        customer: ''
      }
    }
  },
  watch: {
    preStatuses: {
      immediate: true,
      handler(val) {
        if (val.length > 0) {
          this.getOrderStatus()
        }
      }
    }
  },
  created() {
    const service = this.$dragula.$service
    service.eventBus.$on('drop', this.handleDrop)
  },
  beforeDestroy() {
    const service = this.$dragula.$service
    service.eventBus.$off('drop', this.handleDrop)
  },
  methods: {
    /**
     * Obtiene la lista de productos asociados a la orden actual y la asigna a
     * `cartlist`. Si no hay productos en la orden y el estado principal de la
     * orden es "quote", muestra un mensaje de error al usuario.
     *
     * @author Rosana Mendez <rosanamendez5 at gmail.com>
     */
    async getCartlist(pk) {
      const cart = await this.$api.sale.suborder.show({
        pk: pk,
        opt: { params: { order: true } }
      })

      this.cartlist = cart.data
      this.quotationData.cartlist = cart.data
    },
    /**
     * Muestra el modal para asignar un diseñador a la suborden.
     *
     * @param {Number} pk ID del producto de la suborden a la que se le asignará
     *                    un diseñador.
     *
     */
    showModalAssignDesigner(pk) {
      if (this.checkPermissions.isElevatedRole) {
        this.modalProduct = pk
        this.showAssignDesignerModal = true
        this.getCartlist(pk)
      }
    },
    /**
     * Muestra el modal para asignar un productor a la suborden.
     *
     * @param {Number} pk ID del producto de la suborden a la que se le asignará
     *                    un productor.
     *
     */
    showModalAssignProductor(pk) {
      if (this.checkPermissions.isElevatedRole) {
        this.modalProduct = pk
        this.showAssignProductorModal = true
      }
    },
    /**
     * Maneja la respuesta del usuario en el modal.
     *
     * @param {boolean} assign  Indica la selección del usuario
     *
     * @author Ing. Argenis Osorio (argenisosorio10 at gmail)
     */
    handleModalResponse(assign) {
      if (assign) {
        this.showAssigUser = true
      } else {
        this.closeModal()
      }
    },
    /**
     * Cierra el modal de asignación de diseñador.
     *
     * @author Ing. Argenis Osorio (argenisosorio10 at gmail)
     */
    closeModal() {
      this.showAssigUser = false
      this.showAssignDesignerModal = false
    },
    expanded(key) {
      this.$set(
        this.expand,
        key,
        this.expand[key] !== undefined ? !this.expand[key] : true
      )
    },
    generateStylesDict(colors) {
      return {
        card: {
          border: `1px solid ${colors.color}`
        },
        customerTitle: {
          color: colors.dark ? 'white' : 'black',
          'background-color': colors.color
        },
        statusIndicate: {
          color: colors.dark ? 'white' : 'black',
          'background-color': colors.color,
          padding: '3px 6px',
          'border-top-left-radius': '0px',
          'border-top-right-radius': '10px',
          'border-bottom-right-radius': '10px',
          'border-bottom-left-radius': '12px',
          'text-align': 'center'
        }
      }
    },
    /**
     * Método que consulta y filtra los estados de subOrden
     * según la parte del proceso en que se encuentra y
     * que no tienen el campo hidden activo
     *
     * Miguel E. Villamizar R. <mevr02 at gmail.com>
     * Rosana Mendez <rosanamendez5 at gmail.com>
     */
    async getOrderStatus() {
      try {
        this.loadStatus = true
        let statuses = this.preStatuses.filter(
          (event) => event.root == this.filter
        )
        this.statuses = statuses.filter((event) => event.hidden == false)
        this.stylesList = this.statuses.map((item) =>
          this.generateStylesDict({
            color: item.color,
            dark: item.dark
          })
        )
      } finally {
        this.loadStatus = false
      }
    },
    /**
     * Método para redireccionar la aplicación a una orden de venta específica.
     * @param {Number} suborderPK   ID de la orden de venta que se quiere
     *                              consultar.
     * @param {Number} [page=0]     Página del formulario de órdenes de venta
     *                              que se quiere mostrar al redireccionar.
     * @returns {Void}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    changeRoute(order = { pk: 0 }, page = 0) {
      this.$router.push({
        name: 'sale-pk',
        params: {
          pk: this.codification({ code: order.pk }),
          step: this.codification({ code: page })
        }
      })
    },
    /**
     * Método para abrir la modal de subórdenes de venta
     * @param {Number} suborderPK   ID de la suborden de venta que se quiere
     *                              consultar.
     * @returns {Void}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    openSuborder(suborderPK) {
      this.$refs.dialprod.open(suborderPK)
    },
    /**
     * Método para generar una cotización de orden de venta en un pdf
     *
     * @param   {Number} orderPK    Primary Key de la orden
     * @param   {Boolean} download  Indica si el archivo es para descargar o
     *                              para verlo en el navegador.
     * @returns {Void}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    generatePDF(
      orderPK,
      download = false,
      productCode = '',
      quotationCode = '',
      parentStatus = ''
    ) {
      let quoteCode = quotationCode || ''
      let orderCode = ''
      if (productCode) {
        let baseCode = productCode.includes('-')
          ? productCode.split('-').slice(0, -1).join('-')
          : productCode
        if (baseCode.startsWith('COT')) {
          if (!quoteCode) quoteCode = baseCode
        } else if (baseCode.startsWith('ORD') || baseCode) {
          orderCode = baseCode
        }
      }

      const isApproved =
        parentStatus &&
        parentStatus !== 'quote' &&
        parentStatus !== 'sended_quote' &&
        parentStatus !== 'correction' &&
        parentStatus !== 'draft'

      let finalCode = ''
      if (isApproved && quoteCode && orderCode && quoteCode !== orderCode) {
        finalCode = `${quoteCode}_${orderCode}`
      } else {
        finalCode = quoteCode || orderCode
      }

      const codeSuffix = finalCode ? `_${finalCode}` : ''
      this.downloadFile({
        api: 'quotation',
        method: 'pdf',
        filename: `Quotation${codeSuffix}`,
        action: download ? 'download' : 'window',
        ext: 'pdf',
        opt: { pk: orderPK }
      })
    },
    /**
     * Método para filtrar la información del cliente de la orden
     * @param {Number} customerPK ID del cliente de la orden
     * @returns {Void}
     *
     * @author Rosana Mendez <rosanamendez5 at gmail.com>
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    async getCustomer(customerPK) {
      try {
        const customer = await this.$api.customer.show({
          pk: customerPK
        })
        this.quotationData.customer = customer.data
      } catch (error) {
        console.error('Error en getCustomer', error)
      }
    },
    /**
     * Método que consulta la orden de venta para asegurarse que llega la
     * información en con el formato adecuado, ya que el componente de
     * cotizaciones no recibe un dato sino un objeto completo.
     *
     * @param {Number} orderPK ID de la orden
     * @returns {Void}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    async getOrder(orderPK) {
      try {
        const orderData = await this.$api.sale.show({
          pk: orderPK
        })
        this.quotationData.order = orderData.data
        this.quotationData.status = orderData.data.mainStatus
      } catch (error) {
        console.error('Error en getOrder', error)
      }
    },
    /**
     * Método que consulta la orden de venta para asegurarse que llega la
     * información en con el formato adecuado, ya que el componente de
     * cotizaciones no recibe un dato sino un objeto completo.
     *
     * @param {Number} orderPK ID de la orden
     * @returns {Void}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    async getQuoteInfo(orderPK, customerPK) {
      this.loading = true
      try {
        await this.getCustomer(customerPK)
        await this.getOrder(orderPK)
        await this.getCartlist(orderPK)
        this.quotationData.load = true
      } catch (error) {
        console.error('Error en getQuoteInfo', error)
      } finally {
        this.loading = false
      }
    },
    /**
     * Método que llama al método update dentro del componente de cotizaciones
     * para realizar distintas acciones.
     *
     * @param {String} mode Acción que realizará el componente de cotizaciones.
     * @returns {Void}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    manageQuote(mode) {
      this.$refs['quote'].update(mode)
    },
    /**
     * Evento que envía una señal al componente de orders.vue para que recargue
     * los estados.
     *
     * @returns {Void}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    updateStatuses() {
      this.$emit('quotation-event')
    },
    /**
     * showOrderUserModal
     * Método para mostrar el modal de usuarios asignados a la suborden
     * @param {Number} product - Producto seleccionado
     *
     */
    showOrderUserModal(product) {
      if (!this.showOrderUser[product.pk]) {
        this.modalProduct = product.pk
        if (product.status.includes('design')) {
          this.userModalMode[product.pk] = 'designer'
        } else if (product.status.includes('production')) {
          this.userModalMode[product.pk] = 'production'
        } else if (product.status.includes('delivery')) {
          this.userModalMode[product.pk] = 'driver'
        }
        this.$set(this.showOrderUser, product.pk, true)
      } else {
        this.$set(this.showOrderUser, product.pk, false)
        this.modalProduct = ''
      }
    },
    /**
     * getDepartments
     * Método para consultar los departamentos asociados a la empresa
     *
     * Angelo Osorio <danielking.321 at gmail.com>
     */
    async getDepartments() {
      this.departments = []
      try {
        const query = await this.$api.department.list({
          opt: {
            params: {
              company_id: this.company.pk
            }
          }
        })
        this.departments = query.data.results
      } catch (error) {
        console.error(error)
      }
    },
    softUpdate() {
      this.$emit('quotation-event')
    },
    handleDrop(block) {
      this.product = Number(block.el.dataset.key)
      this.newStatus = Number(block.container.dataset.status)
    },
    /**
     * Método para redireccionar la aplicación a una cuenta por cobrar
     * específica.
     *
     * @param {Number} receivable        ID de la cuenta por cobrar
     * @returns {Void}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    async goToReceivable(orderPK) {
      await this.$api.invoice.receivable
        .byOrder({
          pk: orderPK
        })
        .then((response) => {
          this.$router.push({
            name: 'receivable-pk',
            params: {
              pk: this.codification({ code: response.data.pk })
            }
          })
        })
        .catch((error) => {
          console.error(error)
        })
    }
  },
  computed: {
    ...mapGetters({
      getPermissions: 'session/getPermissions',
      getTotalNotifications: 'notifications/getTotalNotifications',
      company: 'company/getCompanyData'
    }),
    email() {
      let values = []
      let newStatus = this.statuses.find((item) =>
        item.pk == this.newStatus ? item : ''
      )
      if (newStatus != undefined) {
        values['status_id'] = newStatus.pk
        values['newStatusName'] = newStatus.name
        values['email'] = newStatus.email
        for (let status of this.statuses) {
          let product = status.products.find((item) => item.pk == this.product)
          if (product != undefined) {
            values['productName'] = product.productName
            values['customerEmail'] = product.customerEmail
            values['customerNotification'] = product.customerNotification
            values['code'] = product.code
          }
        }
      }
      return values
    },
    /**
     * Determina si el usuario tiene los permisos necesarios según la indicación
     *
     * @returns {Object} Objeto con los permisos del usuario.
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    checkPermissions() {
      return {
        isElevatedRole:
          this.getPermissions([`users.change_profile`]) &&
          this.getPermissions([`auth.change_user`]),
        isDesigner:
          this.getPermissions([`sales.change_assigneduser`]) &&
          this.getPermissions([`sales.view_assigneduser`])
      }
    }
  },
  mounted() {
    this.getDepartments()
  }
}
</script>
<style lang="sass">
.status-dashboard
  display: flex
  flex-direction: column
  width: 400px
  height: auto
  overflow-y: auto
  max-height: 70vh
  gap: 10px
  scrollbar-width: thin
  scrollbar-color: var(--secundary) transparent

  .status-card
    position: relative
    padding: 0
    width: 100%

  .suborders-container
    min-height: 50px
    padding-top: 1px
    padding-bottom: 20px
    background-color: rgb(219 219 219 / 0.5)
    border-bottom-left-radius: 8px
    border-bottom-right-radius: 8px
    display: flex
    flex-direction: column
    gap: 2px
    .suborder
      cursor: grab
      &:active,
      &:focus
        cursor: grabbing
      &.gu-transit
        cursor: grabbing

  .dashboard-title
    margin-bottom: 0
    text-transform: uppercase
    text-align: center
    font-weight: 500
    font-size: 0.75rem
    line-height: 1.25rem
    font-family: "Roboto", sans-serif
    letter-spacing: 0.0333333333em
    padding: 10px
    border-top-left-radius: 8px
    border-top-right-radius: 8px

.suborder
  // -------------------------------
  // Tarjetas de subórdenes de venta
  // -------------------------------
  font-weight: 500
  font-size: 0.75rem
  line-height: 1.25rem
  font-family: "Roboto", sans-serif
  letter-spacing: 0.0333333333em
  overflow: hidden

.suborder-chip
  // ---------------------------------------------
  // Cabecera de las tarjetas - Nombre del cliente
  // ---------------------------------------------
  font-weight: 700
  border-top-left-radius: 12px
  border-bottom-right-radius: 12px
  padding: 6px 8px

.suborder-data
  // ----------------------
  // Cuerpo de las tarjetas
  // ----------------------
  padding: 15px 5px
  display: grid
  grid-template-columns: 80px 1fr 34px
  align-items: start
  gap: 5px

.suborder-buttons
  // -----------------------
  // Botones de las tarjetas
  // -----------------------
  justify-self: center
  display: flex
  flex-direction: column
  gap: 10px

.suborder-footer
  display: grid
  grid-template-columns: 1fr 34px
  align-items: center

.theme--dark
  .status-dashboard
    .suborders-container
      background-color: rgb(74, 74, 74, .8)

.gu-mirror
  position: fixed !important
  margin: 0 !important
  z-index: 9999 !important
  opacity: 0.8
  -ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=80)'
  filter: alpha(opacity=80)
.gu-hide
  display: none !important
.gu-unselectable
  -webkit-user-select: none !important
  -moz-user-select: none !important
  -ms-user-select: none !important
  user-select: none !important
.gu-transit
  opacity: 0.2
  -ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=20)'
  filter: alpha(opacity=20)
</style>
